import { Button } from "react-bootstrap";

const DialogFooter = ({
  submitting,
  isFormValid,
  isUpdateMode,
  onCancel,
  onSubmit,
  cancelLabel = "Cancel",
  className = "dialog-footer mt-3",
}) => (
  <div className={className}>
    <Button variant="secondary" onClick={onCancel} disabled={submitting}>
      {cancelLabel}
    </Button>
    <Button variant="primary" onClick={onSubmit} disabled={!isFormValid || submitting}>
      {submitting ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          {isUpdateMode ? "Updating..." : "Creating..."}
        </>
      ) : isUpdateMode ? (
        "Update"
      ) : (
        "Create"
      )}
    </Button>
  </div>
);

export default DialogFooter;
